import { render, staticRenderFns } from "./Rex.vue?vue&type=template&id=aa13893a&"
import script from "./Rex.vue?vue&type=script&lang=js&"
export * from "./Rex.vue?vue&type=script&lang=js&"
import style0 from "./Rex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports